export const DDC_PAGE_VEHICLEDETAILVIEW = 'ddc.page.vehicleDetailView';

function vehicleDetailView({
	DDC: {
		dataLayer: {
			page: {
				pageInfo: { isVdp, pageName }
			}
		}
	}
}) {
	return isVdp
		? {
				eventType: DDC_PAGE_VEHICLEDETAILVIEW,
				eventData: {
					alias: pageName
				}
		  }
		: undefined;
}

export default vehicleDetailView;
